const user = [
  {
    name: "Congress",
    email: "congress@gmail.com",
    password: "congress@123",
    type: "superAdmin",
  },
  {
    name: "BJP",
    email: "bjp@gmail.com",
    password: "bjp@123",
    type: "superAdmin",
  },
  {
    name: "Beffin",
    email: "beffin@gmail.com",
    password: "beffin@123",
    type: "admin",
  },
  {
    name: "Abhinav",
    email: "abhinav@gmail.com",
    password: "abhinav@123",
    type: "admin",
  },
];

export {user} 

